import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';
import { getUrlPathFromParams } from 'site-modules/shared/utils/core-breadcrumbs-builder';
import { CoreBreadcrumbs } from 'site-modules/shared/components/core-breadcrumbs/core-breadcrumbs';
import { ErrorBoundary } from 'site-modules/shared/components/error-boundary/error-boundary';

export const AppraiserBreadcrumbs = ({
  estimatedVehicle,
  params,
  className = 'px-0 mb-0 text-white text-shadow-contrast',
}) => (
  <Col xs={12}>
    <ErrorBoundary>
      <CoreBreadcrumbs
        className={className}
        useDefaultYearV2
        vehicle={{
          make: { name: estimatedVehicle.makeName, slug: estimatedVehicle.makeSlug },
          model: { name: estimatedVehicle.modelName, slug: estimatedVehicle.modelSlug },
          submodels: estimatedVehicle.submodels,
          year: estimatedVehicle.year,
        }}
        breadcrumbsParams={{
          params,
          pageDisplayName: 'Appraisal value',
          includeLastLink: true,
          urlPath: getUrlPathFromParams(params, 'appraisal-value'),
        }}
      />
    </ErrorBoundary>
  </Col>
);

AppraiserBreadcrumbs.propTypes = {
  className: PropTypes.string,
  estimatedVehicle: PropTypes.shape({
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    makeName: PropTypes.string.isRequired,
    makeSlug: PropTypes.string,
    modelName: PropTypes.string.isRequired,
    modelSlug: PropTypes.string,
    submodels: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  params: PropTypes.shape({}).isRequired,
};
